import { OffersOrderingComponent } from './offers-ordering.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ OffersOrderingComponent });
